import { useEffect } from 'react'
import { adminSocketService } from '../services/socketService'
import { getStoredToken } from '../services/api'

export function useAdminSocketInit() {
  useEffect(() => {
    const token = getStoredToken()
    if (token && !adminSocketService.connected) {
      adminSocketService.connect(token)
    }
  }, [])
}
